import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsUS: CultureInfo = {
  name: 'es-US',
  displayName: 'Spanish (United States)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-US',
  parent: CultureInfoEs
};
